<template>
  <async-loader v-if="!isSplashEnabled" />
  <app-section-wrap v-else :modifier="'login --terms'">
    <div class="card" column="xs-12 s-12 m-8 +m-2">
      <h1 class="grape text-captialize _pl0">{{ cloudCannonContent.title }}</h1>
      <cloud-cannon-content class="_p0 transparent grape"
        :content-loading="cloudCannonContentLoading"
        :content="cloudCannonContent.broker_splash_summary"
      />
      <form @submit.prevent="goToEyeManage">
        <async-button type="submit" class=" --sm" v-if="!cloudCannonContentLoading" :executing="submitting">
          <template #buttonContent>
            <span>Continue to EyeManage</span>
          </template>
        </async-button>
      </form>
      <button id="reject" v-if="!cloudCannonContentLoading" class="_mtxs --sm lips"
              @click.prevent="goToMeyeBroker">{{ cloudCannonContent.broker_link_text }} </button>
    </div>
  </app-section-wrap>
</template>
<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import cloudCannonable from '@mixins/CloudCannonable'
  import fetchable from '@mixins/fetchable'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    mixins: [fetchable, cloudCannonable],
    components: {
      AppSectionWrap,
      AsyncButton,
      AsyncLoader
    },
    data() {
      return {
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/broker_splash.json'
            }
          }
        ],
        isSplashEnabled: false,
        submitting: false
      }
    },
    methods: {
      goToEyeManage() {
        this.$router.push({ name: 'dashboard' }).catch((e) => {
          if(e.name !== 'NavigationDuplicated') {
            throw e;
          }
        });
      },
      goToMeyeBroker() {
        window.location.href = process.env.VUE_APP_MEYEBROKER_URL
      }
    },
    async beforeMount() {
      if (this.$store.state.auth.userRole.accountType !== 'B') {
        this.goToEyeManage()
      }
      await this.$store.dispatch('cloudCannon/GET_CLOUD_CANNON_CONTENT', { cloudCannonResource: '/broker_splash.json' })
      if (!this.cloudCannonContent.is_splash_enabled) {
        this.goToEyeManage()
      }
      this.isSplashEnabled = true
    }
  }
</script>
